import { useState, useEffect } from "react";
import { useGetAllCourseQuery } from "src/services/CourseService";

const useCourse = () => {
    const [course, setCourse] = useState<any[]>([]);
    const [isDataLoading, setIsDataLoading] = useState(true);

    const { data, isLoading, isFetching } = useGetAllCourseQuery("");

    useEffect(() => {
        if (isLoading || isFetching) {
            setIsDataLoading(true);
        } else {
            const result: any[] = data?.data;
            setCourse(result || []);
            setIsDataLoading(false);
        }
    }, [data, isLoading, isFetching]);

    return { course, isDataLoading };
};

export default useCourse;
